import { Form, InputNumber } from "antd";
import './index.less';
import { useTranslation } from "react-i18next";
import { getSymbol } from "@/config/symbol";

function InputNumberAddon({ symbol, ...restProps }: any) {
  return (
    <div className="input-number-addon-box">
      <InputNumber className="mini-input-number" {...restProps} controls={false} />
      <div className="addon">
        {symbol}
      </div>
    </div>
  );
}

export default function RemainAmount({ form, symbol }: any) {
  const { t } = useTranslation()
  return (
    <div className="fixed-amount-box">
      <h3>{ t("manyToMany.reserveAmountPerAddress") }</h3>
      <Form.Item
        name="remainAmount"
        label={null}
        rules={[
          { required: true, message:  t("manyToMany.amountIsRequired") },
          { type: 'number', min: 0.0001, message:  t("manyToMany.amountMustBeGreaterThanZero") }
        ]}
      >
        <InputNumberAddon symbol={symbol || getSymbol()}  precision={4}/>
      </Form.Item>
    </div>
  );
}
